import { Chip } from '@mui/material';
import { colors } from '../../styles/fontStyles';
import { SxProps, Theme } from '@mui/material/styles';

type ChipLabelGuidelineProps = {
  label: string;
  borderColor?: string;
  bgcolor?: string;
  padding?: string;
  labelColor?: string;
  sxProps?: SxProps<Theme>;
};

const ChipLabelGuideline = (props: ChipLabelGuidelineProps) => {
  const { label, borderColor = colors.white, labelColor = colors.blue900, sxProps, ...restProps } = props;
  return (
    <Chip
      label={label}
      {...restProps}
      sx={{
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '700',
        border: `2px solid ${borderColor}`,
        color: labelColor,
        '& .MuiChip-label': {
          padding: '0',
        },
        ...sxProps,
      }}
    />
  );
};

export default ChipLabelGuideline;
